// Developer preview routing (OpenFlame).
//
// When a UI runs from the OpenFlame workspace (started from the console's
// User Interfaces page), the workspace API puts the developer's nickname in
// the bundler's public env. Sending it as the `x-openflame-dev` header makes
// the cluster's dev routes deliver the request to the service dev run in
// that developer's workspace instead of the deployed service — for that
// developer only; everyone else keeps the deployed service. Outside a
// workspace run the variable is unset and nothing is added.

export const OPENFLAME_DEV_HEADER = 'x-openflame-dev';

/** The developer nickname set by the workspace API, or '' when not in a workspace run. */
export function openflameDeveloper(): string {
  const env: Record<string, string | undefined> = (typeof process !== 'undefined' && process && process.env) || {};
  return env.REACT_APP_OPENFLAME_DEV || env.EXPO_PUBLIC_OPENFLAME_DEV || env.NEXT_PUBLIC_OPENFLAME_DEV || '';
}

/** Headers to add to every API request: {} outside a workspace run. */
export function openflameDevHeaders(): Record<string, string> {
  const dev = openflameDeveloper();
  return dev ? { [OPENFLAME_DEV_HEADER]: dev } : {};
}

/** Adds the header on a @hey-api/client-fetch client; no-op outside a workspace run. */
export function applyOpenflameDevRouting(client: {
  interceptors: { request: { use: (fn: (request: Request) => Request | Promise<Request>) => unknown } };
}): void {
  const dev = openflameDeveloper();
  if (!dev) return;
  client.interceptors.request.use((request) => {
    request.headers.set(OPENFLAME_DEV_HEADER, dev);
    return request;
  });
}
